'use strict';

const $ = require('jquery');

class Lightbox {

    constructor() {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        $('[data-lightbox-video]').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>'
        });

        $('[data-lightbox-image]').magnificPopup({
            type: 'image',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>'
        });

    }

}

module.exports = Lightbox;
